// WARNING: This file was auto generated by the code in web-rnd/tygen.
// Do not commit manual changes to this file.

/** AccessTokenFilter */
export interface DtoAccessTokenFilter {
	cid: number;
	prdCat: string;
	version: string;
	priceList: string;
	vendor: string;
}

/** AccessTokenListResponse */
export interface DtoAccessTokenListResponse {
	tokens: Array<DtoDynamoAccessToken>;
}

/** AccessTokenOwner */
export interface DtoAccessTokenOwner {
	id: string;
	name: string;
}

/** AccessTokenOwnerResponse */
export interface DtoAccessTokenOwnerResponse {
	owner: DtoAccessTokenOwner;
}

/** AccessTokenRequest */
export interface DtoAccessTokenRequest {
	name: string;
	filters: Array<DtoAccessTokenFilter>;
	origins: Array<string>;
	public: boolean;
}

/** AccessTokenResponse */
export interface DtoAccessTokenResponse {
	token: DtoDynamoAccessToken;
}

/** AdditionalProductConfiguration */
export interface DtoAdditionalProductConfiguration {
	refKey?: string;
	selected?: boolean;
	selOptions: Array<DtoSelectedOption>;
	additionalProducts?: Array<DtoAdditionalProductConfiguration>;
}

/** AuthorizeResponse - The response to an authorize request. It contains an endpoint, a session token and an API session. The endpoint is the URL to access the API. The secret token is used to validate each request to the API. The API session contains information about the user's catalogue access. */
export interface DtoAuthorizeResponse {
	endpoint: string;
	secretToken: string;
	apiSession: DtoCatalogueAPISession;
}

/** CacheFilterType */
export type DtoCacheFilterType = "Contains" | "StartsWith";
export const dtoCacheFilterTypeNames: DtoCacheFilterType[] = ["Contains", "StartsWith"];

/** CacheKeyData */
export interface DtoCacheKeyData {
	key: string;
	keyType: string;
}

/** CacheManagementResponse */
export interface DtoCacheManagementResponse {
	keys: Array<DtoCacheKeyData>;
}

/** CacheParams */
export interface DtoCacheParams {
	filterString?: string;
	filterType?: DtoCacheFilterType;
	region: DtoCacheRegion;
	limit?: number;
}

/** CacheParamsClearCache */
export interface DtoCacheParamsClearCache {
	region: DtoCacheRegion;
	keyType: DtoKeyType;
}

/** CacheParamsWithKey */
export interface DtoCacheParamsWithKey {
	region: DtoCacheRegion;
	key: string;
}

/** CacheRegion */
export type DtoCacheRegion = "ap" | "eu" | "us";
export const dtoCacheRegionNames: DtoCacheRegion[] = ["ap", "eu", "us"];

/** CacheResponse */
export interface DtoCacheResponse {
	data: string;
}

/** CacheValueResponse */
export interface DtoCacheValueResponse {
	value: { [index: string]: string };
}

/** Catalogue */
export interface DtoCatalogue {
	dbName: string;
	enterprise: string;
	prdCats?: Array<DtoProductCatalogue>;
	vendors?: Array<string>;
	url?: string;
	modified: number;
}

/** CatalogueAPISession */
export interface DtoCatalogueAPISession {
	expires: string;
	features?: Array<string>;
	permissions?: Array<DtoCataloguePermission>;
}

/** CatalogueParams - To identify one catalogue the Portfolio ID CID is needed in addition to the parameters in this object. However as of now CID is not used in API calls and therefore this version without CID is needed. */
export interface DtoCatalogueParams {
	enterprise: string;
	prdCat: string;
	prdCatVersion: string;
	vendor: string;
	priceList: string;
}

/** CatalogueParamsWithCid */
export interface DtoCatalogueParamsWithCid extends DtoCatalogueParams {
	cid: number;
}

/** CatalogueParamsWithCidAndLang */
export interface DtoCatalogueParamsWithCidAndLang extends DtoCatalogueParamsWithCid {
	lang: string;
}

/** CataloguePermission */
export interface DtoCataloguePermission {
	cid: number;
	enterprise: string;
	prdCat: string;
	prdCatVersion: string;
	priceLists?: Array<string>;
	vendors?: Array<string>;
}

/** ClearCacheKeysResponse */
export interface DtoClearCacheKeysResponse {
	data: Array<string>;
}

/** CreateAccessTokenResponse */
export interface DtoCreateAccessTokenResponse {
	token: DtoDynamoAccessToken;
	secretToken: string;
}

/** DailyUsage */
export interface DtoDailyUsage extends DtoDynamoObject {
	data?: { [index: string]: { [index: string]: number } };
}

/** DeleteAggregatedDailyUsageByDateParams represents the URL parameters of deleteAggregatedDailyUsageByDate */
export interface DtoDeleteAggregatedDailyUsageByDateParams {
	year: number;
	month: number;
	day: number;
}

/** DeleteAggregatedHourlyUsageByHourParams represents the URL parameters of deleteAggregatedHourlyUsageByHour */
export interface DtoDeleteAggregatedHourlyUsageByHourParams {
	year: number;
	month: number;
	day: number;
	hour: number;
}

/** DynamoAccessToken - Is used to authorize new SessionTokens */
export interface DtoDynamoAccessToken extends DtoDynamoObject {
	cataloguePermissions?: Array<DtoCataloguePermission>;
	expires: string;
	features?: Array<string>;
	filters?: Array<DtoAccessTokenFilter>;
	name?: string;
	public?: boolean;
	inactive?: boolean;
	inactiveToggleTimestamp: string;
	origins?: Array<string>;
}

/** DynamoObject - Common properties that are shared between all objects we put into DynamoDB */
export interface DtoDynamoObject {
	pk: string; // partitionKey
	sk: string; // sortKey
	it: string; // itemType
	cr: string; // created
	mo: string; // modified
	ow: string; // owner
	ttl: number; // time to live
}

/** EmptyResponse */
export interface DtoEmptyResponse {}

/** ErrorResponse */
export interface DtoErrorResponse {
	error: string;
	code: number;
	eventId?: string;
}

/** ExportFormat - Format of the exported product, identical to the format's file extension. */
export type DtoExportFormat = "glb" | "gltf" | "fbx" | "dwg" | "cmdrw" | "cmfav" | "cmsym";
export const dtoExportFormatNames: DtoExportFormat[] = ["glb", "gltf", "fbx", "dwg", "cmdrw", "cmfav", "cmsym"];

/** GetAccessTokenListByManufacturerParams represents the URL parameters of getAccessTokenListByManufacturer */
export interface DtoGetAccessTokenListByManufacturerParams {
	id: number;
}

/** GetAccessTokenOwnerParams represents the URL parameters of getAccessTokenOwner */
export interface DtoGetAccessTokenOwnerParams {
	pk: string;
}

/** GetAccessTokenParams represents the URL parameters of getAccessToken */
export interface DtoGetAccessTokenParams {
	pk: string;
}

/** GetAggregatedDailyUsageByDateParams represents the URL parameters of getAggregatedDailyUsageByDate */
export interface DtoGetAggregatedDailyUsageByDateParams {
	year: number;
	month: number;
	day: number;
}

/** GetAggregatedDailyUsageByMonthParams represents the URL parameters of getAggregatedDailyUsageByMonth */
export interface DtoGetAggregatedDailyUsageByMonthParams {
	year: number;
	month: number;
}

/** GetAggregatedHourlyUsageByDateParams represents the URL parameters of getAggregatedHourlyUsageByDate */
export interface DtoGetAggregatedHourlyUsageByDateParams {
	year: number;
	month: number;
	day: number;
}

/** GetAggregatedHourlyUsageByHourParams represents the URL parameters of getAggregatedHourlyUsageByHour */
export interface DtoGetAggregatedHourlyUsageByHourParams {
	year: number;
	month: number;
	day: number;
	hour: number;
}

/** GetCataloguesByManufacturerParams represents the URL parameters of getCataloguesByManufacturer */
export interface DtoGetCataloguesByManufacturerParams {
	id: number;
}

/** GetDailyUsageForAccessTokenByMonthParams represents the URL parameters of getDailyUsageForAccessTokenByMonth */
export interface DtoGetDailyUsageForAccessTokenByMonthParams {
	pk: string;
	year: number;
	month: number;
}

/** GetDailyUsageForManufacturerByMonthParams represents the URL parameters of getDailyUsageForManufacturerByMonth */
export interface DtoGetDailyUsageForManufacturerByMonthParams {
	id: number;
	year: number;
	month: number;
}

/** GetDailyUsageForPrimaryAccessTokenByMonthParams represents the URL parameters of getDailyUsageForPrimaryAccessTokenByMonth */
export interface DtoGetDailyUsageForPrimaryAccessTokenByMonthParams {
	pk: string;
	year: number;
	month: number;
}

/** GetHourlyUsageForAccessTokenByDateParams represents the URL parameters of getHourlyUsageForAccessTokenByDate */
export interface DtoGetHourlyUsageForAccessTokenByDateParams {
	pk: string;
	year: number;
	month: number;
	day: number;
}

/** GetHourlyUsageForManufacturerByDateParams represents the URL parameters of getHourlyUsageForManufacturerByDate */
export interface DtoGetHourlyUsageForManufacturerByDateParams {
	id: number;
	year: number;
	month: number;
	day: number;
}

/** GetHourlyUsageForPrimaryAccessTokenByDateParams represents the URL parameters of getHourlyUsageForPrimaryAccessTokenByDate */
export interface DtoGetHourlyUsageForPrimaryAccessTokenByDateParams {
	pk: string;
	year: number;
	month: number;
	day: number;
}

/** GetPrimaryAccessTokenListByManufacturerParams represents the URL parameters of getPrimaryAccessTokenListByManufacturer */
export interface DtoGetPrimaryAccessTokenListByManufacturerParams {
	id: number;
}

/** GetPrimaryAccessTokenParams represents the URL parameters of getPrimaryAccessToken */
export interface DtoGetPrimaryAccessTokenParams {
	pk: string;
}

/** GetTestErrorParams represents the URL parameters of getTestError */
export interface DtoGetTestErrorParams {
	code: number;
}

/** HourlyUsage */
export interface DtoHourlyUsage extends DtoDynamoObject {
	data?: { [index: string]: { [index: string]: number } };
}

/** InternalAuth */
export interface DtoInternalAuth {
	endpoint: string;
	features?: Array<string>;
	secretToken: string;
}

/** InternalCatalogueAPISession */
export interface DtoInternalCatalogueAPISession {
	expires: string;
	features?: Array<string>;
	user: DtoUser;
	sessionId: string;
}

/** KeyType */
export type DtoKeyType = "Production" | "Test" | "RateLimitTest" | "RateLimitProduction";
export const dtoKeyTypeNames: DtoKeyType[] = ["Production", "Test", "RateLimitTest", "RateLimitProduction"];

/** ListCataloguesResponse */
export interface DtoListCataloguesResponse {
	cataloguePermissions: Array<DtoCataloguePermission>;
}

/** LoginRequest */
export interface DtoLoginRequest {
	email: string;
	password: string;
}

/** LoginResponse */
export interface DtoLoginResponse {
	endpoint: string;
	secretToken: string;
	session: DtoInternalCatalogueAPISession;
	auth: DtoAuthorizeResponse;
}

/** LogoutResponse */
export interface DtoLogoutResponse {
	success: boolean;
}

/** Orientation */
export interface DtoOrientation {
	yaw: number; // radians
	pitch: number; // radians
	roll: number; // radians
}

/** PData */
export interface DtoPData {
	catId: DtoCatalogueParams;
	partNumber: string;
	selOptions?: Array<DtoSelectedOption>;
}

/** PDataWithAdditionalProducts */
export interface DtoPDataWithAdditionalProducts {
	catId: DtoCatalogueParams;
	partNumber: string;
	selOptions?: Array<DtoSelectedOption>;
	additionalProducts?: Array<DtoAdditionalProductConfiguration>;
}

/** Point */
export interface DtoPoint {
	x: number;
	y: number;
	z: number;
}

/** Portfolio */
export interface DtoPortfolio extends DtoDynamoObject {
	debug?: boolean;
	urls?: Array<DtoPortfolioUrlDatabaseUrl>;
	catalogues?: Array<DtoCatalogue>;
}

/** PortfolioUrlDatabaseUrl */
export interface DtoPortfolioUrlDatabaseUrl {
	cid: number;
	modified: number;
	url: string;
}

/** PostAccessTokenParams represents the URL parameters of postAccessToken */
export interface DtoPostAccessTokenParams {
	pk: string;
}

/** PostActivateAccessTokenParams represents the URL parameters of postActivateAccessToken */
export interface DtoPostActivateAccessTokenParams {
	pk: string;
}

/** PostAggregatedDailyUsageByDateParams represents the URL parameters of postAggregatedDailyUsageByDate */
export interface DtoPostAggregatedDailyUsageByDateParams {
	year: number;
	month: number;
	day: number;
}

/** PostAggregatedDailyUsageByMonthParams represents the URL parameters of postAggregatedDailyUsageByMonth */
export interface DtoPostAggregatedDailyUsageByMonthParams {
	year: number;
	month: number;
}

/** PostAggregatedHourlyUsageByDateParams represents the URL parameters of postAggregatedHourlyUsageByDate */
export interface DtoPostAggregatedHourlyUsageByDateParams {
	year: number;
	month: number;
	day: number;
}

/** PostAggregatedHourlyUsageByHourParams represents the URL parameters of postAggregatedHourlyUsageByHour */
export interface DtoPostAggregatedHourlyUsageByHourParams {
	year: number;
	month: number;
	day: number;
	hour: number;
}

/** PostCreateAccessTokenForManufacturerParams represents the URL parameters of postCreateAccessTokenForManufacturer */
export interface DtoPostCreateAccessTokenForManufacturerParams {
	id: number;
}

/** PostDeactivateAccessTokenParams represents the URL parameters of postDeactivateAccessToken */
export interface DtoPostDeactivateAccessTokenParams {
	pk: string;
}

/** PostManufacturerAdminSessionTokenParams represents the URL parameters of postManufacturerAdminSessionToken */
export interface DtoPostManufacturerAdminSessionTokenParams {
	id: number;
}

/** PostUsageByDateResponse */
export interface DtoPostUsageByDateResponse {
	date: string;
	usage?: Array<DtoHourlyUsage>;
}

/** ProductCatalogue */
export interface DtoProductCatalogue {
	code: string;
	version: string;
	priceLists?: Array<string>;
}

/** ProductParamsWithCid */
export interface DtoProductParamsWithCid extends DtoCatalogueParamsWithCid {
	partNumber: string;
}

/** ProductParamsWithCidAndLang */
export interface DtoProductParamsWithCidAndLang extends DtoProductParamsWithCid {
	lang: string;
}

/** RefreshSessionTokenResponse - The response to a refresh session token request. It contains a new API session. */
export interface DtoRefreshSessionTokenResponse {
	apiSession: DtoCatalogueAPISession;
}

/** RenderFormat */
export type DtoRenderFormat = "jpg" | "png";
export const dtoRenderFormatNames: DtoRenderFormat[] = ["jpg", "png"];

/** RequestData */
export interface DtoRequestData extends DtoDynamoObject {
	ip: string;
	operationId: string;
	path: string;
	requestId: string;
	requesterId: string;
}

/** SelectedOption */
export interface DtoSelectedOption {
	code: string;
	numericValue?: DtoValueWithUnit;
	next?: { [index: string]: DtoSelectedOption };
}

/** SessionToken - Is used to query the catalogue api */
export interface DtoSessionToken extends DtoDynamoObject {
	cataloguePermissions?: Array<DtoCataloguePermission>;
	expires: string;
	features?: Array<string>;
}

/** TargetCameraArgs */
export interface DtoTargetCameraArgs {
	location?: DtoPoint;
	target?: DtoPoint;
	direction?: DtoVector;
	normal?: DtoVector;
	yaw?: number; // radians
	pitch?: number; // radians
	roll?: number; // radians
	fov?: number; // radians
	nearClip?: number;
	minHeight?: number;
}

/** Transform */
export interface DtoTransform {
	pos: DtoVector;
	scale: DtoVector;
	rot: DtoOrientation;
}

/** UsageByDateResponse */
export interface DtoUsageByDateResponse {
	date: string;
	usage?: Array<DtoHourlyUsage>;
}

/** UsageByMonthResponse */
export interface DtoUsageByMonthResponse {
	date: string;
	usage?: Array<DtoDailyUsage>;
}

/** UsageByOperationByPath */
export interface DtoUsageByOperationByPath {
	[index: string]: { [index: string]: number };
}

/** UsageByOperationByPathWithModified */
export interface DtoUsageByOperationByPathWithModified {
	modified: string;
	data: DtoUsageByOperationByPath;
}

/** UsageByOperationResponse */
export interface DtoUsageByOperationResponse {
	date: string;
	usage: { [index: string]: number };
}

/** UsageByTimeUnitByOperationByPath */
export interface DtoUsageByTimeUnitByOperationByPath {
	[index: string]: DtoUsageByOperationByPathWithModified;
}

/** UsageByTimeUnitResponse */
export interface DtoUsageByTimeUnitResponse {
	date: string;
	timeUnit: DtoUsageTimeUnit;
	usage: DtoUsageByTimeUnitByOperationByPath;
}

/** UsageTimeUnit */
export type DtoUsageTimeUnit = "day" | "hour";
export const dtoUsageTimeUnitNames: DtoUsageTimeUnit[] = ["day", "hour"];

/** User */
export interface DtoUser {
	id: number;
	email: string;
	name: string;
}

/** UserResponse */
export interface DtoUserResponse {
	user: DtoUser;
}

/** ValueWithUnit */
export interface DtoValueWithUnit {
	value: number;
	unit?: string;
}

/** Vector */
export interface DtoVector {
	x: number;
	y: number;
	z: number;
}

export type DtoRequestOptions = {
	method: "POST" | "GET" | "DELETE";
	headers: { [index: string]: string };
	body?: string;
};

export class DtoAPIError<T> extends Error {
	body?: string;
	error?: Error;
	parsed?: T;
	status?: number;
}

type FetchFunc = (input: RequestInfo, init?: RequestInit) => Promise<Response>;
export class InternalCatalogueAPI {
	public auth: DtoInternalAuth | undefined;

	constructor(private readonly _fetch: FetchFunc = window.fetch.bind(window)) {}

	hasFeature(feature: string): boolean {
		return this.auth !== undefined && this.auth.features !== undefined && this.auth.features.indexOf(feature) > -1;
	}

	async fetch<T>(url: string, options: DtoRequestOptions): Promise<T> {
		let response: Response | undefined;
		let body: string | undefined;
		let err: DtoAPIError<DtoErrorResponse> | undefined;

		if (options.method === "POST" && options.body) {
			options.headers["Content-Type"] = "application/json;charset=utf-8";
		}

		try {
			response = await this._fetch(url, options);
			body = await response.text();
			const parsed: T | DtoErrorResponse = JSON.parse(body);

			if (parsed && typeof parsed === "object" && "error" in parsed) {
				err = new DtoAPIError(parsed.error);
				err.body = body;
				err.status = response.status;
				err.parsed = parsed;
			} else {
				return parsed;
			}
		} catch (e) {
			const msg = e instanceof Error ? e.message : `${e}`;
			err = new DtoAPIError(msg);
			err.body = body;
			err.status = response && response.status;
			err.error = e instanceof Error ? e : Error(msg);
		}

		throw err;
	}

	async getAccessToken(params: DtoGetAccessTokenParams): Promise<DtoAccessTokenResponse> {
		if (this.auth === undefined) {
			throw new Error("missing auth");
		}
		const url = `/catadmin/access-token/${encodeURIComponent(params.pk)}`;
		const options: DtoRequestOptions = {
			method: "GET",
			headers: { "X-API-Key": this.auth.secretToken || "" },
		};
		return this.fetch<DtoAccessTokenResponse>(this.auth.endpoint + url, options);
	}

	async postAccessToken(params: DtoPostAccessTokenParams, body: DtoAccessTokenRequest): Promise<DtoAccessTokenResponse> {
		if (this.auth === undefined) {
			throw new Error("missing auth");
		}
		const url = `/catadmin/access-token/${encodeURIComponent(params.pk)}`;
		const options: DtoRequestOptions = {
			method: "POST",
			headers: { "X-API-Key": this.auth.secretToken || "" },
			body: JSON.stringify(body),
		};
		return this.fetch<DtoAccessTokenResponse>(this.auth.endpoint + url, options);
	}

	async postActivateAccessToken(params: DtoPostActivateAccessTokenParams): Promise<DtoAccessTokenResponse> {
		if (this.auth === undefined) {
			throw new Error("missing auth");
		}
		const url = `/catadmin/access-token/${encodeURIComponent(params.pk)}/activate`;
		const options: DtoRequestOptions = {
			method: "POST",
			headers: { "X-API-Key": this.auth.secretToken || "" },
		};
		return this.fetch<DtoAccessTokenResponse>(this.auth.endpoint + url, options);
	}

	async postDeactivateAccessToken(params: DtoPostDeactivateAccessTokenParams): Promise<DtoAccessTokenResponse> {
		if (this.auth === undefined) {
			throw new Error("missing auth");
		}
		const url = `/catadmin/access-token/${encodeURIComponent(params.pk)}/deactivate`;
		const options: DtoRequestOptions = {
			method: "POST",
			headers: { "X-API-Key": this.auth.secretToken || "" },
		};
		return this.fetch<DtoAccessTokenResponse>(this.auth.endpoint + url, options);
	}

	async getAccessTokenOwner(params: DtoGetAccessTokenOwnerParams): Promise<DtoAccessTokenOwnerResponse> {
		if (this.auth === undefined) {
			throw new Error("missing auth");
		}
		const url = `/catadmin/access-token/${encodeURIComponent(params.pk)}/owner`;
		const options: DtoRequestOptions = {
			method: "GET",
			headers: { "X-API-Key": this.auth.secretToken || "" },
		};
		return this.fetch<DtoAccessTokenOwnerResponse>(this.auth.endpoint + url, options);
	}

	async getDailyUsageForAccessTokenByMonth(params: DtoGetDailyUsageForAccessTokenByMonthParams): Promise<DtoUsageByOperationResponse> {
		if (this.auth === undefined) {
			throw new Error("missing auth");
		}
		const url = `/catadmin/access-token/${encodeURIComponent(params.pk)}/usage/daily/${encodeURIComponent(params.year)}/${encodeURIComponent(params.month)}`;
		const options: DtoRequestOptions = {
			method: "GET",
			headers: { "X-API-Key": this.auth.secretToken || "" },
		};
		return this.fetch<DtoUsageByOperationResponse>(this.auth.endpoint + url, options);
	}

	async getHourlyUsageForAccessTokenByDate(params: DtoGetHourlyUsageForAccessTokenByDateParams): Promise<DtoUsageByTimeUnitResponse> {
		if (this.auth === undefined) {
			throw new Error("missing auth");
		}
		const url = `/catadmin/access-token/${encodeURIComponent(params.pk)}/usage/hourly/${encodeURIComponent(params.year)}/${encodeURIComponent(params.month)}/${encodeURIComponent(params.day)}`;
		const options: DtoRequestOptions = {
			method: "GET",
			headers: { "X-API-Key": this.auth.secretToken || "" },
		};
		return this.fetch<DtoUsageByTimeUnitResponse>(this.auth.endpoint + url, options);
	}

	async clearCacheKeys(body: DtoCacheParamsClearCache): Promise<DtoClearCacheKeysResponse> {
		if (this.auth === undefined) {
			throw new Error("missing auth");
		}
		const url = `/catadmin/admin/cache/clear-keys`;
		const options: DtoRequestOptions = {
			method: "POST",
			headers: { "X-API-Key": this.auth.secretToken || "" },
			body: JSON.stringify(body),
		};
		return this.fetch<DtoClearCacheKeysResponse>(this.auth.endpoint + url, options);
	}

	async deleteCacheKey(body: DtoCacheParamsWithKey): Promise<DtoCacheResponse> {
		if (this.auth === undefined) {
			throw new Error("missing auth");
		}
		const url = `/catadmin/admin/cache/delete-key`;
		const options: DtoRequestOptions = {
			method: "POST",
			headers: { "X-API-Key": this.auth.secretToken || "" },
			body: JSON.stringify(body),
		};
		return this.fetch<DtoCacheResponse>(this.auth.endpoint + url, options);
	}

	async getCacheValue(body: DtoCacheParamsWithKey): Promise<DtoCacheValueResponse> {
		if (this.auth === undefined) {
			throw new Error("missing auth");
		}
		const url = `/catadmin/admin/cache/get`;
		const options: DtoRequestOptions = {
			method: "POST",
			headers: { "X-API-Key": this.auth.secretToken || "" },
			body: JSON.stringify(body),
		};
		return this.fetch<DtoCacheValueResponse>(this.auth.endpoint + url, options);
	}

	async getCacheInfo(body: DtoCacheParams): Promise<DtoCacheResponse> {
		if (this.auth === undefined) {
			throw new Error("missing auth");
		}
		const url = `/catadmin/admin/cache/info`;
		const options: DtoRequestOptions = {
			method: "POST",
			headers: { "X-API-Key": this.auth.secretToken || "" },
			body: JSON.stringify(body),
		};
		return this.fetch<DtoCacheResponse>(this.auth.endpoint + url, options);
	}

	async scanCacheKeys(body: DtoCacheParams): Promise<DtoCacheManagementResponse> {
		if (this.auth === undefined) {
			throw new Error("missing auth");
		}
		const url = `/catadmin/admin/cache/scan`;
		const options: DtoRequestOptions = {
			method: "POST",
			headers: { "X-API-Key": this.auth.secretToken || "" },
			body: JSON.stringify(body),
		};
		return this.fetch<DtoCacheManagementResponse>(this.auth.endpoint + url, options);
	}

	async postAdminRefreshDynamo(): Promise<DtoEmptyResponse> {
		if (this.auth === undefined) {
			throw new Error("missing auth");
		}
		const url = `/catadmin/admin/refresh-dynamo`;
		const options: DtoRequestOptions = {
			method: "POST",
			headers: { "X-API-Key": this.auth.secretToken || "" },
		};
		return this.fetch<DtoEmptyResponse>(this.auth.endpoint + url, options);
	}

	async getAggregatedDailyUsageByMonth(params: DtoGetAggregatedDailyUsageByMonthParams): Promise<DtoUsageByMonthResponse> {
		if (this.auth === undefined) {
			throw new Error("missing auth");
		}
		const url = `/catadmin/aggregated-usage/daily/${encodeURIComponent(params.year)}/${encodeURIComponent(params.month)}`;
		const options: DtoRequestOptions = {
			method: "GET",
			headers: { "X-API-Key": this.auth.secretToken || "" },
		};
		return this.fetch<DtoUsageByMonthResponse>(this.auth.endpoint + url, options);
	}

	async postAggregatedDailyUsageByMonth(params: DtoPostAggregatedDailyUsageByMonthParams): Promise<DtoUsageByMonthResponse> {
		if (this.auth === undefined) {
			throw new Error("missing auth");
		}
		const url = `/catadmin/aggregated-usage/daily/${encodeURIComponent(params.year)}/${encodeURIComponent(params.month)}`;
		const options: DtoRequestOptions = {
			method: "POST",
			headers: { "X-API-Key": this.auth.secretToken || "" },
		};
		return this.fetch<DtoUsageByMonthResponse>(this.auth.endpoint + url, options);
	}

	async getAggregatedDailyUsageByDate(params: DtoGetAggregatedDailyUsageByDateParams): Promise<DtoDailyUsage> {
		if (this.auth === undefined) {
			throw new Error("missing auth");
		}
		const url = `/catadmin/aggregated-usage/daily/${encodeURIComponent(params.year)}/${encodeURIComponent(params.month)}/${encodeURIComponent(params.day)}`;
		const options: DtoRequestOptions = {
			method: "GET",
			headers: { "X-API-Key": this.auth.secretToken || "" },
		};
		return this.fetch<DtoDailyUsage>(this.auth.endpoint + url, options);
	}

	async postAggregatedDailyUsageByDate(params: DtoPostAggregatedDailyUsageByDateParams): Promise<DtoDailyUsage> {
		if (this.auth === undefined) {
			throw new Error("missing auth");
		}
		const url = `/catadmin/aggregated-usage/daily/${encodeURIComponent(params.year)}/${encodeURIComponent(params.month)}/${encodeURIComponent(params.day)}`;
		const options: DtoRequestOptions = {
			method: "POST",
			headers: { "X-API-Key": this.auth.secretToken || "" },
		};
		return this.fetch<DtoDailyUsage>(this.auth.endpoint + url, options);
	}

	async deleteAggregatedDailyUsageByDate(params: DtoDeleteAggregatedDailyUsageByDateParams): Promise<DtoEmptyResponse> {
		if (this.auth === undefined) {
			throw new Error("missing auth");
		}
		const url = `/catadmin/aggregated-usage/daily/${encodeURIComponent(params.year)}/${encodeURIComponent(params.month)}/${encodeURIComponent(params.day)}`;
		const options: DtoRequestOptions = {
			method: "DELETE",
			headers: { "X-API-Key": this.auth.secretToken || "" },
		};
		return this.fetch<DtoEmptyResponse>(this.auth.endpoint + url, options);
	}

	async getAggregatedHourlyUsageByDate(params: DtoGetAggregatedHourlyUsageByDateParams): Promise<DtoUsageByDateResponse> {
		if (this.auth === undefined) {
			throw new Error("missing auth");
		}
		const url = `/catadmin/aggregated-usage/hourly/${encodeURIComponent(params.year)}/${encodeURIComponent(params.month)}/${encodeURIComponent(params.day)}`;
		const options: DtoRequestOptions = {
			method: "GET",
			headers: { "X-API-Key": this.auth.secretToken || "" },
		};
		return this.fetch<DtoUsageByDateResponse>(this.auth.endpoint + url, options);
	}

	async postAggregatedHourlyUsageByDate(params: DtoPostAggregatedHourlyUsageByDateParams): Promise<DtoUsageByDateResponse> {
		if (this.auth === undefined) {
			throw new Error("missing auth");
		}
		const url = `/catadmin/aggregated-usage/hourly/${encodeURIComponent(params.year)}/${encodeURIComponent(params.month)}/${encodeURIComponent(params.day)}`;
		const options: DtoRequestOptions = {
			method: "POST",
			headers: { "X-API-Key": this.auth.secretToken || "" },
		};
		return this.fetch<DtoUsageByDateResponse>(this.auth.endpoint + url, options);
	}

	async getAggregatedHourlyUsageByHour(params: DtoGetAggregatedHourlyUsageByHourParams): Promise<DtoHourlyUsage> {
		if (this.auth === undefined) {
			throw new Error("missing auth");
		}
		const url = `/catadmin/aggregated-usage/hourly/${encodeURIComponent(params.year)}/${encodeURIComponent(params.month)}/${encodeURIComponent(params.day)}/${encodeURIComponent(params.hour)}`;
		const options: DtoRequestOptions = {
			method: "GET",
			headers: { "X-API-Key": this.auth.secretToken || "" },
		};
		return this.fetch<DtoHourlyUsage>(this.auth.endpoint + url, options);
	}

	async postAggregatedHourlyUsageByHour(params: DtoPostAggregatedHourlyUsageByHourParams): Promise<DtoHourlyUsage> {
		if (this.auth === undefined) {
			throw new Error("missing auth");
		}
		const url = `/catadmin/aggregated-usage/hourly/${encodeURIComponent(params.year)}/${encodeURIComponent(params.month)}/${encodeURIComponent(params.day)}/${encodeURIComponent(params.hour)}`;
		const options: DtoRequestOptions = {
			method: "POST",
			headers: { "X-API-Key": this.auth.secretToken || "" },
		};
		return this.fetch<DtoHourlyUsage>(this.auth.endpoint + url, options);
	}

	async deleteAggregatedHourlyUsageByHour(params: DtoDeleteAggregatedHourlyUsageByHourParams): Promise<DtoEmptyResponse> {
		if (this.auth === undefined) {
			throw new Error("missing auth");
		}
		const url = `/catadmin/aggregated-usage/hourly/${encodeURIComponent(params.year)}/${encodeURIComponent(params.month)}/${encodeURIComponent(params.day)}/${encodeURIComponent(params.hour)}`;
		const options: DtoRequestOptions = {
			method: "DELETE",
			headers: { "X-API-Key": this.auth.secretToken || "" },
		};
		return this.fetch<DtoEmptyResponse>(this.auth.endpoint + url, options);
	}

	async postDebugBrowsingSessionToken(): Promise<DtoAuthorizeResponse> {
		if (this.auth === undefined) {
			throw new Error("missing auth");
		}
		const url = `/catadmin/debug-browsing-session-token`;
		const options: DtoRequestOptions = {
			method: "POST",
			headers: { "X-API-Key": this.auth.secretToken || "" },
		};
		return this.fetch<DtoAuthorizeResponse>(this.auth.endpoint + url, options);
	}

	async postLogin(endpoint: string, body: DtoLoginRequest): Promise<DtoLoginResponse> {
		const url = `/catadmin/login`;
		const options: DtoRequestOptions = {
			method: "POST",
			headers: {},
			body: JSON.stringify(body),
		};
		return this.fetch<DtoLoginResponse>(endpoint + url, options);
	}

	async getLogout(): Promise<DtoLogoutResponse> {
		if (this.auth === undefined) {
			throw new Error("missing auth");
		}
		const url = `/catadmin/logout`;
		const options: DtoRequestOptions = {
			method: "GET",
			headers: { "X-API-Key": this.auth.secretToken || "" },
		};
		return this.fetch<DtoLogoutResponse>(this.auth.endpoint + url, options);
	}

	async getAccessTokenListByManufacturer(params: DtoGetAccessTokenListByManufacturerParams): Promise<DtoAccessTokenListResponse> {
		if (this.auth === undefined) {
			throw new Error("missing auth");
		}
		const url = `/catadmin/manufacturer/${encodeURIComponent(params.id)}/access-token`;
		const options: DtoRequestOptions = {
			method: "GET",
			headers: { "X-API-Key": this.auth.secretToken || "" },
		};
		return this.fetch<DtoAccessTokenListResponse>(this.auth.endpoint + url, options);
	}

	async postCreateAccessTokenForManufacturer(params: DtoPostCreateAccessTokenForManufacturerParams, body: DtoAccessTokenRequest): Promise<DtoCreateAccessTokenResponse> {
		if (this.auth === undefined) {
			throw new Error("missing auth");
		}
		const url = `/catadmin/manufacturer/${encodeURIComponent(params.id)}/access-token`;
		const options: DtoRequestOptions = {
			method: "POST",
			headers: { "X-API-Key": this.auth.secretToken || "" },
			body: JSON.stringify(body),
		};
		return this.fetch<DtoCreateAccessTokenResponse>(this.auth.endpoint + url, options);
	}

	async postManufacturerAdminSessionToken(params: DtoPostManufacturerAdminSessionTokenParams): Promise<DtoAuthorizeResponse> {
		if (this.auth === undefined) {
			throw new Error("missing auth");
		}
		const url = `/catadmin/manufacturer/${encodeURIComponent(params.id)}/admin-session-token`;
		const options: DtoRequestOptions = {
			method: "POST",
			headers: { "X-API-Key": this.auth.secretToken || "" },
		};
		return this.fetch<DtoAuthorizeResponse>(this.auth.endpoint + url, options);
	}

	async getCataloguesByManufacturer(params: DtoGetCataloguesByManufacturerParams): Promise<DtoListCataloguesResponse> {
		if (this.auth === undefined) {
			throw new Error("missing auth");
		}
		const url = `/catadmin/manufacturer/${encodeURIComponent(params.id)}/catalogues`;
		const options: DtoRequestOptions = {
			method: "GET",
			headers: { "X-API-Key": this.auth.secretToken || "" },
		};
		return this.fetch<DtoListCataloguesResponse>(this.auth.endpoint + url, options);
	}

	async getDailyUsageForManufacturerByMonth(params: DtoGetDailyUsageForManufacturerByMonthParams): Promise<DtoUsageByOperationResponse> {
		if (this.auth === undefined) {
			throw new Error("missing auth");
		}
		const url = `/catadmin/manufacturer/${encodeURIComponent(params.id)}/usage/daily/${encodeURIComponent(params.year)}/${encodeURIComponent(params.month)}`;
		const options: DtoRequestOptions = {
			method: "GET",
			headers: { "X-API-Key": this.auth.secretToken || "" },
		};
		return this.fetch<DtoUsageByOperationResponse>(this.auth.endpoint + url, options);
	}

	async getHourlyUsageForManufacturerByDate(params: DtoGetHourlyUsageForManufacturerByDateParams): Promise<DtoUsageByTimeUnitResponse> {
		if (this.auth === undefined) {
			throw new Error("missing auth");
		}
		const url = `/catadmin/manufacturer/${encodeURIComponent(params.id)}/usage/hourly/${encodeURIComponent(params.year)}/${encodeURIComponent(params.month)}/${encodeURIComponent(params.day)}`;
		const options: DtoRequestOptions = {
			method: "GET",
			headers: { "X-API-Key": this.auth.secretToken || "" },
		};
		return this.fetch<DtoUsageByTimeUnitResponse>(this.auth.endpoint + url, options);
	}

	async getPrimaryAccessTokenList(): Promise<DtoAccessTokenListResponse> {
		if (this.auth === undefined) {
			throw new Error("missing auth");
		}
		const url = `/catadmin/primary-access-token`;
		const options: DtoRequestOptions = {
			method: "GET",
			headers: { "X-API-Key": this.auth.secretToken || "" },
		};
		return this.fetch<DtoAccessTokenListResponse>(this.auth.endpoint + url, options);
	}

	async getDailyUsageForPrimaryAccessTokenByMonth(params: DtoGetDailyUsageForPrimaryAccessTokenByMonthParams): Promise<DtoUsageByMonthResponse> {
		if (this.auth === undefined) {
			throw new Error("missing auth");
		}
		const url = `/catadmin/primary-access-token/${encodeURIComponent(params.pk)}/usage/daily/${encodeURIComponent(params.year)}/${encodeURIComponent(params.month)}`;
		const options: DtoRequestOptions = {
			method: "GET",
			headers: { "X-API-Key": this.auth.secretToken || "" },
		};
		return this.fetch<DtoUsageByMonthResponse>(this.auth.endpoint + url, options);
	}

	async getHourlyUsageForPrimaryAccessTokenByDate(params: DtoGetHourlyUsageForPrimaryAccessTokenByDateParams): Promise<DtoUsageByDateResponse> {
		if (this.auth === undefined) {
			throw new Error("missing auth");
		}
		const url = `/catadmin/primary-access-token/${encodeURIComponent(params.pk)}/usage/hourly/${encodeURIComponent(params.year)}/${encodeURIComponent(params.month)}/${encodeURIComponent(params.day)}`;
		const options: DtoRequestOptions = {
			method: "GET",
			headers: { "X-API-Key": this.auth.secretToken || "" },
		};
		return this.fetch<DtoUsageByDateResponse>(this.auth.endpoint + url, options);
	}

	async getTestError(params: DtoGetTestErrorParams): Promise<DtoEmptyResponse> {
		if (this.auth === undefined) {
			throw new Error("missing auth");
		}
		const url = `/catadmin/test/error/${encodeURIComponent(params.code)}`;
		const options: DtoRequestOptions = {
			method: "GET",
			headers: { "X-API-Key": this.auth.secretToken || "" },
		};
		return this.fetch<DtoEmptyResponse>(this.auth.endpoint + url, options);
	}

	async getUser(): Promise<DtoUserResponse> {
		if (this.auth === undefined) {
			throw new Error("missing auth");
		}
		const url = `/catadmin/user`;
		const options: DtoRequestOptions = {
			method: "GET",
			headers: { "X-API-Key": this.auth.secretToken || "" },
		};
		return this.fetch<DtoUserResponse>(this.auth.endpoint + url, options);
	}
}
